import { collection, doc, endBefore, getDoc, getDocs, getFirestore, limit, limitToLast, orderBy, Query, query, QueryDocumentSnapshot, QuerySnapshot, startAfter, startAt, where } from "firebase/firestore";
import employeeConverter from "../converters/employeeConverter";
import passportRequestConverter from "../converters/passportRequestConverter";
import { PassportRequest, PassportRequestStatus } from "../types/PassportRequest";
import { RequestStatus } from "../types/Type";

export interface PassportsQueryResult {
  first: QueryDocumentSnapshot,
  last: QueryDocumentSnapshot,
  results: PassportRequest[],
  totalCount: number,
}

export const queryPassportRequests = async (
  page: 'initial' | 'forward' | 'backward' | 'same',
  passportPerPage: number, 
  status: PassportRequestStatus | 'All' = 'New', 
  start: QueryDocumentSnapshot |  null = null, 
  end: QueryDocumentSnapshot | null = null) => {

  const db = getFirestore();
  let q: Query<PassportRequest> | undefined;

  if (page === 'initial' || (!start && !end)) {
    q = query(collection(db, 'PassportRequests'), orderBy('dateRequested', 'desc'), limit(passportPerPage)).withConverter(passportRequestConverter);
  } else if (page === 'forward') {
    q = query(collection(db, 'PassportRequests'), orderBy('dateRequested', 'desc'), startAfter(end), limit(passportPerPage)).withConverter(passportRequestConverter);
  } else if (page === 'backward') {
    q = query(collection(db, 'PassportRequests'), orderBy('dateRequested', 'desc'), endBefore(start), limitToLast(passportPerPage)).withConverter(passportRequestConverter);
  } else {
    q = query(collection(db, 'PassportRequests'), orderBy('dateRequested', 'desc'), startAt(start), limit(passportPerPage)).withConverter(passportRequestConverter);
  }

  if (q) {
    let totalCount = 0;
    const vConf = (await getDoc(doc(db, `Configs/PassportRequests`))).data()!;

    if (status !== 'All') {
      q = query(q, where('status', '==', status));
      totalCount = vConf[status + 'Count'];
    } else {
      totalCount = vConf.TotalCount;
    }
    
    const querySnapshot = await getDocs(q);
    const vqr: PassportsQueryResult = {
      first: querySnapshot.docs[0],
      last: querySnapshot.docs[querySnapshot.docs.length - 1],
      results: querySnapshot.docs.map((d) => d.data()),
      totalCount,
    };

    return vqr;
  }
};

export const queryPassportRequestsByIdNumber = async (idNumber: string) => {
  const db = getFirestore();
  const q = query(collection(db, `PassportRequests`), where('idNumber', '==', idNumber), orderBy('dateRequested', 'desc')).withConverter(passportRequestConverter);
  return (await getDocs(q)).docs.map((d) => d.data());
};